import React from 'react'
import { AdminSidebarLayout } from '../../components/AdminSidebar'
import { AdminHeader } from '../../components/components'
import GigCategoryForm from '../../components/admins/GigCategoryForm'


const NewCategory = () => {
    return (

        <AdminSidebarLayout currentPath="/new-category">
            <div className="bg-[#F5F5F5] dark:bg-[#0b0e14] min-h-screen px-4 py-8">
                <AdminHeader/>
                <div className="container mx-auto">
                    <GigCategoryForm/>
                </div>
            </div>
        </AdminSidebarLayout>
    )
}

export default NewCategory